var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowlnoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C10.2733 0 0 10.2733 0 23C0 35.7267 10.2733 46 23 46C35.7267 46 46 35.7267 46 23C46 10.2733 35.7267 0 23 0ZM19.9333 21.7222L20.0356 11.5H26.0156L26.1178 21.7222L29.44 20.9556L23 29.3889L16.6111 20.9556L19.9333 21.7222ZM34.5 34.5H11.5V29.3889H14.0556V31.9444H31.9444V29.3889H34.5V34.5Z",
    fill: "#365644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowlnoad);
export default __webpack_public_path__ + "static/media/dowlnoad.c8345b6393b730616acdd5ad74f43cdf.svg";
export { ForwardRef as ReactComponent };